import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useAPI from "../../../../../../../../api/hooks/useAPI";
import { remediationAuditLogKeys } from "../../../../../../../../api/queryKeys";
import LoadingIcon from "../../../../../../../../components/LoadingIcon";
import HistoryLogCollapse from "./HistoryLogCollapse";

export default function AutoRemediationHistory({ remediations }) {
  const { getAllAuditLogs } = useAPI();

  const auditLogsQuery = useQuery({
    queryKey: remediationAuditLogKeys.all,
    queryFn: getAllAuditLogs,

    select: (result) =>
      result.data.sort(
        (a, b) => b.log_timestamp.timestamp_utc - a.log_timestamp.timestamp_utc
      ),
  });

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle1">Auto-Remediation History</Typography>
      {auditLogsQuery.isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          height="100%"
          alignItems="center"
        >
          <LoadingIcon size={14} />
        </Box>
      ) : (
        auditLogsQuery.isSuccess &&
        (auditLogsQuery.data.length > 0 ? (
          <Box display="flex" flexDirection="column">
            {auditLogsQuery.data.map((auditLog, index) => {
              const remediation = remediations.find(
                (remediation) =>
                  remediation.remediation_id === auditLog.remediation_id
              );
              if (!remediation) {
                return null;
              }
              const isMostRecentLog = index === 0;
              const isOldestLog = index === auditLogsQuery.data.length - 1;
              return (
                <HistoryLogCollapse
                  key={auditLog.log_id}
                  auditLog={auditLog}
                  remediation={remediation}
                  isMostRecentLog={isMostRecentLog}
                  showTopConnectLine={!isMostRecentLog}
                  showBottomConnectLine={!isOldestLog}
                />
              );
            })}
          </Box>
        ) : (
          <Typography variant="body2">No auto-remediation history</Typography>
        ))
      )}
    </Box>
  );
}
